import React from 'react'
import { transaction } from "~/redux/user/actions";
import { subscribe, cancelSubscribe } from "~/redux/user/subscription";
import {format} from 'date-fns';
import getSymbolFromCurrency from "currency-symbol-map";
import { getToken } from '~/redux/user/tokens'
import { get } from 'lodash'

class Verify extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.webSocketBaseUrl = window.settings.apiBaseUrl && window.settings.apiBaseUrl.replace('api','ws').replace('https','wss');
  }

  setMonthFormat(month){
    if(month > 9){
      return month
    }
    return `0${month}`
  }

  componentDidMount() {
    this.paymentLine()
  }
  componentDidUpdate() {
    this.paymentLine()
  }
  setYearFormat(year){
    return `${year}`.substr(2)
  }
  loadingScreen = () => {
    this.props.overlay({ styles: { backgroundColor: '#777575CC', zIndex: 2 }, loading: true, message: this.getVal('paymentProcessingMessage') || 'Please wait while we confirm your payment' })
  }
  handleError = () => {
    this.props.overlay({ styles: {display:'none'}, loading: false })
  }

  subscribe = () => {
    if(window.settings.paymentProviders.stripe && window.settings.paymentProviders.stripe.transactionalPayment) {
      this.loadingScreen();
      subscribe({
        plan: this.props.plan,
        billingToken: this.props.user.billingInfo,
        offerCode: this.props.offerCode && this.props.offerCode.code
      }).then(()=> {
        getToken().then((token) => {
          var paymentSocket = new WebSocket(this.webSocketBaseUrl + "/notification?token="+ token)
          var isPaymentinProcess = false;
          var subscribeMessage =  {
						"action": "subscribe",
						"eventType": "SUBSCRIPTION",
						"token" : token
					}
          var ref = this;
          paymentSocket.onopen = function() {
            console.log('socket opened')
            paymentSocket.send(JSON.stringify(subscribeMessage));
            setTimeout(()=>{
              if(!isPaymentinProcess){
                paymentSocket.close();
                ref.props.success(null, "InProcess");
                cancelSubscribe();
              }
            },60000)
          }
          paymentSocket.onmessage = function (event) {
            console.log('socket message received');
            isPaymentinProcess = true;
            var paymentData = event.data && JSON.parse(event.data)
            ref.setState({
              loading: false
            })
            if(paymentData.event == "subscription" && paymentData.status == "completed") {
              ref.props.success();
            } else {
              ref.props.success(null, "Failed");
              cancelSubscribe();
            }
            paymentSocket.close();
          }
          paymentSocket.onerror = function (err) {
            console.log("connection error");
            isPaymentinProcess = true;
            paymentSocket.close();
            ref.setState({
              loading: false
            })
            ref.props.success(null, "InProcess");
            cancelSubscribe();
          }
        })
      }, (err) => {
        this.handleError();
        this.setState({
          loading: false,
          error: err.response.data.error || err.response.data.message
        })
        setTimeout(_ => this.setState({ ...this.state, error: null }), 5000)
      })
    } else {
      subscribe({
        plan: this.props.plan,
        billingToken: this.props.user.billingInfo,
        offerCode: this.props.offerCode && this.props.offerCode.code
      }).then((data) => {
        this.setState({
          loading: false
        })
        this.props.success(data);
      }).catch(err =>{
        this.setState({
          loading: false,
          error: err.response.data.error || err.response.data.message
        })
        setTimeout(_ => this.setState({ ...this.state, error: null }), 5000)
      })
    }

  }
  getVal(key){
    return get(this.props.metadataMap, key)
  }

  paymentLine(){
    const price = (this.props.plan.price || (this.props.plan.planDetails && this.props.plan.planDetails[0].recurringPaymentAmount))
    const priceText = document.getElementById('priceSpan')
    const purchaseText = document.getElementById('purchaseText')
    if(priceText)
      priceText.innerHTML = '$'+price.toFixed(2)
    if(purchaseText)
      purchaseText.innerHTML = this.props.subscription ? this.getVal('verifySubscribeNow') : this.getVal('verifyPay')
  }

  purchase(){
    const { plan, user, content, success } = this.props
    const isEpisode = () => content.gist.contentType === 'VIDEO' && (plan.seasonId && plan.seriesId)
    const data={}
    data.amount = plan.price
    data.transaction = 'stripe'
    data.stripeToken = user.billingInfo.stripeToken.card.id
    data.contentRequest = {
      contentType: isEpisode() ? 'EPISODE' : content.gist.contentType,
      contentId: plan.contentID ? plan.contentID : plan.videoID,
      videoIds: plan.videoID,
      seasonId: plan.seasonId,
      seriesId: plan.seriesId,
      videoQuality: 'HD'
    }
    data.purchaseType = plan.option.toUpperCase()
    data.platform = "web_browser"
    data.siteId = window.settings.siteId
    data.currencyCode = "USD"
    data.requestId = user.billingInfo.requestId;
    data.userId = user.userId
    data.email = user.email
    data.site = window.settings.internalName;
    transaction(data).then(response=>{
      success(plan.videoID);
      this.setState({loading: false})
    }).catch(err =>{
      this.setState({
        loading: false,
        error: err.response.data.error
      })
      setTimeout(_ => this.setState({ ...this.state, error: null }), 5000)
    })
  }
  
  render() {
    if(this.props.user && this.props.user.billingInfo){
      const price = (this.props.plan.price || (this.props.plan.planDetails && this.props.plan.planDetails[0].recurringPaymentAmount))
      const { plan } = this.props
      const pd = plan.planDetails && plan.planDetails[0]
      const card = this.props.user && this.props.user.billingInfo.stripeToken.card

      return <div className="verify-info">
          <div className="header">
            <p>{this.getVal('verifyTitle')}</p> 
            {this.props.firstPayment ? <div className="desc">
              <span className="first-payment">{this.getVal('verifyFirstPay')}</span>
              <span className="price">
                &nbsp;
                {getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}
                {this.props.firstPayment.amount.toFixed(2)}
              </span> {this.getVal('verifyTax')} {format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY")}
            </div>:
            <p>
              <span dangerouslySetInnerHTML={{__html: this.getVal('verifyPaymentInfo')}}></span>
            </p>
            }
            <p>{this.getVal('verifyPaymentMessage')}</p>
          </div>
          <div className="verify-details">
            <div className="verify-details-left">
              <p>
              <span className="bold">{this.props.subscription ? this.getVal('verifySubscribeHeader') : this.getVal('verifyPurchaseHeader')}</span> ({pd && getSymbolFromCurrency(pd.recurringPaymentCurrencyCode) || `$`}{price.toFixed(2)})
              </p>
            </div>
            <div className="verify-details-center">
            <p><span className="bold">{this.getVal('verifyAddressHeader')}</span></p>
              <p>{this.props.user.name}</p>
              <p>{card['address_line1']} {card['address_line2']}</p>
              <p>{card['address_city']}, {card['address_country']}, {card['address_zip']}</p>
            </div>
            <div className="verify-details-right">
            <p className="bold card-edit">{this.getVal('verifyCardHeader')} <span className="edit" onClick={this.props.edit}>{this.getVal('verifyEditCard')}</span></p> 
              <p>************{card.last4}</p>
              <p><span className="bold">{this.getVal('verifyCardExpires')}:</span> {this.setMonthFormat(card['exp_month'])}/{this.setYearFormat(card['exp_year'])}</p>
            </div>
          </div>
          <div className="legal-texts" dangerouslySetInnerHTML={{ __html: this.getVal('verifyLegalText')}}/>
          <div className="verify-button overlay-button site-background-color" 
            onClick={()=>{
              if(this.state.loading){
                return
              }
              if(this.props.subscription) {
                this.subscribe()
              }else {
                this.purchase()
              }
              this.setState({loading: true})
            }
          }>
          {this.state.loading ? <p className="processing">{this.getVal('paymentProcessing')}<span>.</span><span>.</span><span>.</span></p>:<button>{this.props.subscription ? this.getVal('verifySubscribeNow') : this.getVal('verifyPay')}</button>}
          </div>
        {this.state.error && <p className="site-color error">{this.state.error}</p>}
        </div>;
    } else {
      return <div />
    }
  } 
}

export default Verify;